import React from "react"

const shimmer =
	"animate-pulse bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-md"

const Box = ({ className }) => <div className={`${shimmer} ${className}`} />

const MetricCardSkeleton = () => (
	<div className="bg-white shadow-md rounded-lg p-5">
		<Box className="h-3 w-32 mb-3" />
		<Box className="h-10 w-24 mb-2" />
		<Box className="h-3 w-20" />
	</div>
)

const GraphSkeleton = ({ height = "h-64" }) => (
	<div className="bg-white shadow-md rounded-lg p-5">
		<Box className="h-5 w-48 mb-4" />
		<Box className={`${height} w-full`} />
	</div>
)

const KPIDashboardSkeleton = ({ sidebarOpen }) => (
	<div className={`${sidebarOpen ? "pl-64" : "pl-8"}`}>
		<div className="my-5 flex h-16 items-center justify-between bg-white px-4 sm:px-6 lg:px-8">
			<Box className="h-9 w-72" />
		</div>

		<div className="px-4 sm:px-6 lg:px-8 mb-6 flex items-center gap-4">
			<Box className="h-10 w-48" />
			<Box className="h-10 w-48" />
			<Box className="h-10 w-32" />
		</div>

		<main className="py-6 px-4 sm:px-6 lg:px-8 space-y-6">
			<div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
				<MetricCardSkeleton />
				<MetricCardSkeleton />
				<MetricCardSkeleton />
				<MetricCardSkeleton />
			</div>

			<GraphSkeleton height="h-80" />

			<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
				<GraphSkeleton />
				<GraphSkeleton />
			</div>

			<GraphSkeleton height="h-72" />
		</main>
	</div>
)

export default KPIDashboardSkeleton
export { GraphSkeleton }
